import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AuthView from "../views/AuthView.vue";
import AuthService from "../api/AuthService";
import LoginForm from "@/components/LoginForm.vue";
import ModoSelect from "@/components/ModoSelect.vue";
import ElegibilidadForm from "@/components/ElegibilidadForm.vue"
import BasicView from "@/views/BasicView.vue";
import InfoPaciente from "@/components/InfoPaciente.vue";
import store from "@/store"
import ListadoSolicitudes from "@/components/ListadoSolicitudes.vue";
import NewPasswordForm from "@/components/NewPasswordForm.vue";
import ContactosPage from "@/components/ContactosPage.vue";
import FacturadorSelect from "@/components/FacturadorSelect.vue";
import {Role} from "@/_helpers/role";
import ReintegroHome from "@/components/ReintegroHome.vue"
import Estadisticas from "@/components/Estadisticas.vue";
import ListadoReintegros from "@/components/ListadoReintegros.vue";
import PacienteSelect from "@/components/PacienteSelect.vue";
import AdminHome from "@/components/AdminHome.vue";
import CargaPorTurnoHome from "@/components/CargaPorTurnoHome.vue";
import OsSelect from "@/components/OsSelect.vue";
import Error from "@/components/Error.vue";
import ReporteTandil from "@/components/ReporteTandil.vue";

const authService = new AuthService();
const DEFAULT_TITLE = 'Prestacional ACEAPP';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/auth/login",
  },
  {
    path: "/auth",
    redirect: "/auth/login",
  },
  {
    path: "/cargar-prestacion",
    redirect: "/cargar-prestacion/elegibilidad",
  },
  {
    path: "/auditoria",
    redirect: "/auditoria/eleccion-os",
  },
  {
    path: "/reintegros",
    redirect: "/reintegros/carga-datos",
  },
  {
    path: "/auditoria-reintegros",
    redirect: "/auditoria-reintegros/eleccion-paciente",
  },
  {
    path: "/estadista",
    redirect: "/estadista/estadisticas",
  },
  {
    path: "/administrador",
    redirect: "/administrador/carga",
  },
  {
    path: '/carga-por-turno',
    redirect: '/carga-por-turno/home-turnos',
  },
  {
    path: "/auth",
    name: "auth",
    component: AuthView,
    children: [
      {
        path: "cambiar-contrasenia",
        name: "cambiar-contrasenia",
        component: NewPasswordForm,
        meta: { requiresAuth: true },
        props: (route) => ({ primerLogin: route.query.primerLogin }),
      },
      {
        path: "login",
        name: "login",
        component: LoginForm,
      },
      {
        path: "eleccion-modo",
        name: "eleccion-modo",
        component: ModoSelect,
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/cargar-prestacion",
    name: "cargarPrestacion",
    component: BasicView,
    children: [
      {
        path:"elegibilidad",
        name:"elegibilidad",
        component: ElegibilidadForm,
        meta: { requiresAuth: true, requiresModoSelected: true, roles: [Role.AdministrativoFacturador, Role.FacturadorIOMA] },
      },
      {
        path:"detalles-paciente",
        name:"detalles-paciente",
        component: InfoPaciente,
        meta: { requiresAuth: true, requiresModoSelected: true, requiresPaciente: true ,roles: [Role.AdministrativoFacturador, Role.FacturadorIOMA] },
      }
    ]
  },
  {
    path: "/listado-solicitudes",
    name: "listado-solicitudes",
    component: BasicView,
    children: [
      {
        path:"",
        component: ListadoSolicitudes,
        meta: { requiresAuth: true, requiresModoSelected: true, roles: [Role.AdministrativoFacturador, Role.FacturadorIOMA, Role.AuditorGeneral] },
      }
    ]
  },
  {
    path: "/listado-solicitudes-autorizador",
    name: "listado-solicitudes-autorizador",
    component: BasicView,
    children: [
      {
        path:"",
        component: ListadoSolicitudes,
        meta: { requiresAuth: true, requiresModoSelected: false, roles: [Role.Autorizador] },
      }
    ]
  },
  {
    path: '/mesa-de-ayuda',
    name: 'mesa-de-ayuda',
    component: BasicView,
    children: [
      {
        path: "",
        component: ContactosPage,
      },
    ]
  },
  {
    path: '/auditoria',
    name: 'auditoria',
    component: BasicView,
    children: [
      {
        path: "eleccion-os",
        name: "eleccion-os",
        component: OsSelect,
        meta: { roles: [Role.Auditor] },
      },
      {
        path: "listado-solicitudes-auditor",
        name: "listado-solicitudes-auditor",
        component: ListadoSolicitudes,
        meta: { roles: [Role.Auditor] },
      }
    ],
  },
  {
    path: '/reintegros',
    name: 'reintegros',
    component: BasicView,
    children: [
      {
        path: 'home',
        name: 'home',
        component: ReintegroHome,
        meta: {requiresAuthExterno: true, requiresPacienteExterno: true, roles: [Role.Paciente]},
      },
      {
        path: 'carga-datos',
        name: 'carga-datos',
        component: ElegibilidadForm,
        meta: {createRoleAndUser: true },
      },
      {
        path: 'info-paciente',
        name: 'info-paciente',
        component: InfoPaciente,
        meta: { requiresAuth: true, requiresPacienteExterno: true, roles: [Role.Paciente]},
      },
      {
        path: 'listado-solicitudes-reintegro',
        name: 'listado-solicitudes-reintegro',
        component: ListadoReintegros,
        meta: { requiresAuthExterno: true, requiresPacienteExterno:true, roles: [Role.Paciente] },
      }
    ]
  },
  {
    path:'/auditoria-reintegros',
    name:'auditoria-reintegros',
    component: BasicView,
    children: [
      {
        path: 'eleccion-paciente',
        name: 'eleccion-paciente',
        component: PacienteSelect,
        meta: { requiresAuth: true, roles: Role.AdministrativoReintegros },
      },
      {
        path: 'listado-reintegros-auditor',
        name: 'listado-reintegros-auditor',
        component: ListadoReintegros,
        meta: { requiresAuth: true, roles: Role.AdministrativoReintegros },
      }
    ]
  },
  {
    path: '/administrador',
    name: 'administrador',
    component: BasicView,
    children: [
      {
        path: 'carga',
        name: 'carga',
        component: AdminHome,
        meta: { requiresAuth: true, roles: Role.Administrador },
      },
      {
        path: 'estadisticas',
        name: 'estadisticas',
        component: Estadisticas,
      }
    ]
  },
  {
    path: '/carga-por-turno',
    name: 'carga-por-turno',
    component: BasicView,
    children: [
      {
        path: 'home-turnos',
        name: 'home-turnos',
        component: CargaPorTurnoHome,
      }
    ]
  },
  {
    path: '/error',
    name: 'error',
    component: BasicView,
    children: [
      {
        path: "",
        component: Error,
      }
    ]
  },
  {
    path: "/reporte-diario",
    name: "reporteDiario",
    component: BasicView,
    children: [
      {
        path:"",
        component: ReporteTandil,
        // meta: { requiresAuth: true, requiresModoSelected: true, roles: [Role.AdministrativoFacturador, Role.FacturadorIOMA] },
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/auth/login',
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = DEFAULT_TITLE;
});

router.beforeEach(async (to, from, next) => {
  store.dispatch('checkTokenExpiration'); // Chequea si el token de autenticación expiró
  const isAuthenticated = store.getters.isAuthenticated;  // Verifica si el usuario está autenticado
  const modoSeleccionado = store.getters.getNivel != "";  // Verifica si el modo fue seleccionado
  const hasPaciente = store.getters.getPaciente ? true : false;  // Verifica si tiene un paciente seleccionado

  //solo chequeo que este logueado si lo requiere y sus roles no incluye usuarioExterno
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      return next('/auth/login');  // Redirige al login si no está autenticado
    }
  }

  if (to.matched.some(record => record.meta.requiresAuthExterno)) {
    if (!isAuthenticated) {
      return next('/reintegros/carga-datos');  // Redirige al carga-datos si no está autenticado
    }
  }

  if(to.matched.some(record => record.meta.requiresModoSelected)){
    if (!modoSeleccionado) {
      if (isAuthenticated) {
        return next('/auth/eleccion-modo');  // Redirige a la elección de modo si no hay uno seleccionado
      }
      return next('/auth/login');
    }
  }

  //filtro que no venga de elegibilidad ya que en ese momento aun no se cargo el paciente pero si paso es porque todo esta ok.
  if (to.matched.some(record => record.meta.requiresPaciente) && (from.path != '/cargar-prestacion/elegibilidad')) {
    if (!hasPaciente) {
      if (isAuthenticated) {
        return next('/cargar-prestacion/elegibilidad');  // Redirige a la página de elegibilidad si no hay paciente
      }
      return next('/auth/login');
    }
  }
  //filtro que no vemga de carga de datos ya que en ese momento aun no se cargo el paciente pero si paso es porque todo esta ok.
  if(to.matched.some(record => record.meta.requiresPacienteExterno)){
    if(!hasPaciente){
      return next('/reintegros/carga-datos');
    }
  }

  if (to.matched.some(record => record.meta.roles)) {
    const role = store.getters.getRole;
    const requiredRoles = to.meta.roles as string[];
    if (!requiredRoles.includes(role)) {
      return next('/auth/login');
    }
  }

  if(to.matched.some(record => record.meta.createRoleAndUser)){
    if(isAuthenticated){
      store.commit("logout", false);
    }
    store.commit('setRole',Role.Paciente);
    await store.dispatch("login",{email:"usuario.externo", password:"usuario.externo"});
  }

  next();  // Si todo está bien, sigue con la navegación
});

export default router;